import React from "react";
import type { BaseProvinceIconProps } from "./BaseProvinceIcon";

export const BritishColumbiaIcon = (props: BaseProvinceIconProps) => {
  return (
    <g
      id="BC"
      {...props}
    >
      <path
        d="M0.3,147.4c0.9,0.4,1.6,0.8,2.3,1.1c1.3,0.6,2.5,1.3,3.8,1.9c1.7,0.9,3.4,1.7,5.2,2.6c2,1,4.1,2.1,6.1,3.1
            c2.2,1.1,4.5,2.3,6.8,3.4c2.3,1.2,4.7,2.4,7,3.6c2.3,1.2,4.6,2.4,6.9,3.5c2.2,1.1,4.3,2.2,6.5,3.3c1.9,1,3.7,1.9,5.6,2.9
            c3.6,1.9,11.7,3.3,14.3,3.8c0.4,0.1,0.7,0.5,0.6,0.9c-2.4,10.6-4.8,21.1-7.2,31.5c-0.7,3-1.5,6-2,9c-0.2,1,0,2.2,0.4,3.1
            c6.7,12.1,13.5,24.1,20.2,36.1c0.2,0.4,0.4,0.7,0.7,1.2c0.3,0.5-0.1,1.1-0.6,1.1c-0.4,0-0.7,0-1-0.1c-13.2-2.9-26.5-5.8-39.7-8.6
            c-1.2-0.3-2-0.8-2.8-1.8c-4.5-6.8-9.2-13.6-13.7-20.4c-0.5-0.7-0.8-1.6-1-2.4c-1-5.2-1.9-10.3-2.8-15.5c-0.1-0.7,0.1-1.5,0.3-2.2
            c1.4-4.5,2.9-8.9,4.2-13.4c0.3-0.9,0.3-1.9,0.1-2.9c-1.7-8.8-3.4-17.5-5.1-26.2c-0.2-1.1-0.7-2.1-1.4-2.9c-1.2-1.3-2.4-2.6-3.6-3.9
            C10.3,159,10,159,9.8,159s-0.4,0.1-0.5,0.2l-1.9,1.6C7.2,161,7,161,6.8,161c-0.3,0-0.6-0.2-0.8-0.4l-2.4-6.1
            c-0.4-1.1-0.8-2.2-1.2-3.3c-0.3-0.8-0.7-1.5-1.2-2.1c-0.3-0.4-0.7-0.7-0.9-1.1C-0.1,147.8,0,147.4,0.3,147.4L0.3,147.4z"
      />
      <path
        d="M6.6,203.4c0.3,0,0.6,0.1,0.9,0.1c0.4,0.1,1,0.2,1.3,0.6c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.2,0.1,0.4,0,0.6
            c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.2-0.3,0.3-0.4,0.5c-0.2,0.3-0.4,0.5-0.7,0.8c-0.3,0.3-0.4,0.7-0.5,1.1l-0.3,4.3
            c0,0.1,0,0.3,0,0.4l0.3,3c0,0.2,0,0.4,0,0.6v0.8c0,0.1,0,0.4-0.2,0.5c-0.1,0-0.3,0.1-0.4,0.1s-0.1,0-0.2-0.1l-0.1-0.1L4.6,215
            c-0.4-0.6-0.6-1.2-0.7-1.9l-0.2-2.4c-0.1-1.4-0.1-2.8,0.1-4.2l0.1-1.2c0-0.2,0.1-0.4,0.2-0.6l0.4-0.4c0.4-0.4,0.8-0.7,1.4-0.8
            C6.2,203.4,6.4,203.4,6.6,203.4L6.6,203.4z"
      />
      <path
        d="M12.1,230.5c0.1,0,0.2,0,0.4,0.1c1.2,0.8,2.3,1.7,3.5,2.6c1.7,1.3,3.5,2.7,5.2,4.1c1.6,1.3,2.3,3.2,3,5.1
            c0.8,2.3,1.6,4.5,2.5,6.8c0.3,0.8,0.6,1.7,0.9,2.5c0.2,0.5,0.8,1.5,0.6,2.1l-0.1,0.2c-0.1,0.2-0.4,0.4-0.7,0.4
            c-0.2,0-0.4-0.1-0.6-0.2c-0.9-0.9-1.9-1.7-2.8-2.6c-1.1-1.1-2.4-2.1-3.5-3.2c-0.9-0.9-1.5-2.1-2.1-3.1c-0.9-1.5-1.8-3.1-2.7-4.7
            c-1.6-2.7-3.1-5.4-4.7-8.1c-0.1-0.2-0.1-0.4,0.1-0.7l0.5-0.8C11.7,230.6,11.9,230.5,12.1,230.5z"
      />
    </g>
  );
};
